import { createReducer } from "@reduxjs/toolkit";
import type { RetrievalState } from "@redux/state/shared-types";
import { adminRetrieveTeacherLessons } from "@academy-context/read/application/use-cases/admin/teacher-lessons-retrieval/retrieve-teacher-lessons";
import type { TeacherLessonListVM } from "@shared-kernel/application/ports/teacher/teacher-repository";

const initialState: RetrievalState<TeacherLessonListVM[]> = { fetching: "idle", data: [] };

export const adminRetrieveTeacherLessonsReducer = createReducer<RetrievalState<TeacherLessonListVM[]>>(initialState, builder => {
  builder.addCase(adminRetrieveTeacherLessons.fulfilled, (state, { payload }) => {
    return {
      ...state,
      data: payload,
      fetching: "success",
    };
  });
  builder.addCase(adminRetrieveTeacherLessons.pending, state => {
    return {
      ...state,
      fetching: "pending",
    };
  });
  builder.addCase(adminRetrieveTeacherLessons.rejected, state => {
    return {
      ...state,
      fetching: "failed",
    };
  });
});
